import styled from "styled-components";
export const EmptyStateContainer = styled.div`
  padding: 64px 0;
  text-align: center;
  line-height: 64px;
  font-size: ${({ theme }) => theme.sizes.font3};
  .icon {
    font-size: ${({ theme }) => theme.sizes.font6};
  }
`;
